/*
  Toggle Switch

  Handles the turning on and turning off of a toggle switch, and emits toggleSwitchUpdate, described in EMITTED EVENTS

  EMITTED EVENTS
    toggleSwitchUpdate (document) Emits when the toggle function is fired (typically on the toggle switch click)
      detail: {
        el:        root element of this controller instance,
        fieldName: the fieldTarget's name,
        val:       the value of the toggle after click
      }
*/

import { createCustomEvent } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['pill', 'field', 'ajaxURL'];

  toggle(event) {
    this.isOn ? this.turnOff() : this.turnOn();
    document.dispatchEvent(createCustomEvent('toggleSwitchUpdate', this.element, {
      fieldName: this.fieldTarget.name,
      val:       this.value
    }));
  }

  //
  // INTERNAL USE
  //

  turnOn() {
    this.pillTarget.classList.add('toggle-switch-on');
    this.isOn = true;
  }

  turnOff() {
    this.pillTarget.classList.remove('toggle-switch-on');
    this.isOn = false;
  }

  //
  // GETTERS AND SETTERS
  //

  get value() {
    return this.fieldTarget.value;
  }

  get isOn() {
    return this.value == '1';
  }

  set isOn(val) {
    this.fieldTarget.value = val ? '1' : null;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/toggle-switch-controller.js